"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _hsIntl = require("../internal/hs-intl");

var _createPublicI18nProvider = _interopRequireDefault(require("./createPublicI18nProvider"));

var _default = function _default(options) {
  var I18nProvider = options && options.shouldSetPublicI18n ? (0, _createPublicI18nProvider.default)(options) : (0, _hsIntl.create)();

  I18nProvider.register = function (lang) {
    var loadOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    I18nProvider.langRegistry[lang.source] = lang;
    var provider = (0, _hsIntl.createLoader)(lang);
    return provider.load(provider.locales, loadOptions).then(function (messages) {
      return messages;
    });
  };

  return I18nProvider;
};

exports.default = _default;
module.exports = exports.default;